import React from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";

import useJoinBooking from "./useJoinBooking";

function JoinBookingView() {
  const { slug, error, navigate } = useJoinBooking();

  if (error) {
    return (
      <Box sx={{ maxWidth: "30rem", mx: "auto", py: 6 }}>
        <Alert
          severity="error"
          action={
            <Button color="error" size="small" onClick={() => navigate(`/${slug}`)}>
              Browse Options
            </Button>
          }
          sx={{ borderRadius: 3 }}
        >
          {error}
        </Alert>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" minHeight="60vh" gap={2}>
      <CircularProgress />
      <Typography color="text.secondary">Opening your booking...</Typography>
    </Box>
  );
}

export default JoinBookingView;
